import { render, staticRenderFns } from "./CertificationCard.vue?vue&type=template&id=501d710c&"
import script from "./CertificationCard.vue?vue&type=script&lang=js&"
export * from "./CertificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports